import React from 'react';
import SearchBar from './SearchBar';
import styled from 'styled-components';
import DropDownFilter from './DropDownFilter';
import GridSelector from './GridSelector';
import ProjectFilter from './ProjectFilter';

const HomeHeaderContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
`;

const RightSide = styled.div`
	flex-basis: 30%;
	display: flex;
	flex-direction: row;
	min-width: 428px;
`;

const HomeHeader = (props) => {
	return (
		<HomeHeaderContainer>
			<ProjectFilter {...props} />
			<SearchBar {...props} />
			<RightSide>
				<DropDownFilter {...props} />
				<GridSelector {...props} />
			</RightSide>
		</HomeHeaderContainer>
	);
};

export default HomeHeader;
